import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  guide: {
    id: 'portal.views.profileGuide.label.guide',
    defaultMessage: 'Guide',
    description: 'Guide label',
  },
  bio: {
    id: 'portal.views.profileGuide.label.bio',
    defaultMessage: 'Bio',
    description: 'Bio label',
  },
  aboutPresentedBy: {
    id: 'portal.views.profileGuide.label.aboutPresentedBy',
    defaultMessage: 'About > <link>Presented By</link> > ',
    description: 'About > Presented By label',
  },
  providingInsight: {
    id: 'portal.views.profileGuide.label.providingInsight',
    defaultMessage: 'Providing insight',
    description: 'Providing insight label',
  },
  inTheseModules: {
    id: 'portal.views.profileGuide.label.inTheseModules',
    defaultMessage: 'in these modules',
    description: 'In these modules label',
  },
  profileNotFoundTitle: {
    id: 'portal.views.profileGuide.label.profileNotFoundTitle',
    defaultMessage: 'Profile unavailable',
    description: 'Heading shown when the requested guide profile is not published or has a private account',
  },
  profileNotFoundBody: {
    id: 'portal.views.profileGuide.label.profileNotFoundBody',
    defaultMessage: 'The user you are looking for does not exist or has a private account.',
    description: 'Body text shown when the requested guide profile is not published or has a private account',
  },
});

export default messages;
